import { render } from "./ProfileTop.vue?vue&type=template&id=3d704829&scoped=true"
import script from "./ProfileTop.vue?vue&type=script&lang=js"
export * from "./ProfileTop.vue?vue&type=script&lang=js"

import "./ProfileTop.vue?vue&type=style&index=0&id=3d704829&lang=css"
import "./ProfileTop.vue?vue&type=style&index=1&id=3d704829&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d704829"]])

export default __exports__